import Permission from '@constants/permission'
import React, { ReactElement } from 'react'
import { Button } from '@mui/material'

import { Add as AddIcon } from '@mui/icons-material'

import Search from '../search/search'
import hasPerms from '@utils/has-permission'
import { useNavigate } from 'react-router-dom'

function Users(): ReactElement {
  const navigate = useNavigate()

  const canUpdateUsers = hasPerms(Permission.USERS_UPDATE)

  const handleNewUserClick = () => navigate('/users/create')

  return (
    <>
      {canUpdateUsers && (
        <Button onClick={handleNewUserClick}>
          <AddIcon />
          Create New User
        </Button>
      )}
      <Search searchHint='Search for registered user accounts by name or email!' />
    </>
  )
}

export default Users
